import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Runtime detection - works in both localhost and production
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

// Helper function to get full URL for assets
const getFullAssetUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${url}`;
};

// Slider Component
function SliderSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    'https://customer-assets.emergentagent.com/job_custom-broker-ui/artifacts/fnnglsgt_1.jpg',
    'https://customer-assets.emergentagent.com/job_custom-broker-ui/artifacts/hv885t9q_2.jpg',
    'https://customer-assets.emergentagent.com/job_custom-broker-ui/artifacts/5wi6o9ms_3.jpg',
    'https://customer-assets.emergentagent.com/job_custom-broker-ui/artifacts/hc13vs5j_4.jpg'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full h-[30vh] overflow-hidden bg-white">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img 
            src={slide} 
            alt={`Slide ${index + 1}`} 
            className="w-full h-full object-cover object-center"
          />
          
          {/* Text Overlay - Only on first slide */}
          {index === 0 && (
            <div className="absolute top-16 left-6 md:top-20 md:left-10">
              <h2 className="text-white text-lg md:text-2xl font-bold leading-snug drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
                Meksa Yatırım'da Hesap
              </h2>
              <h2 className="text-white text-lg md:text-[22px] font-bold leading-snug drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
                Açmak
              </h2>
              <h2 className="text-white text-lg md:text-2xl font-bold leading-snug mt-1 drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
                Meksa Mobile ile Artık Çok...
              </h2>
            </div>
          )}
        </div>
      ))}

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all ${
              index === currentSlide 
                ? 'bg-white w-7' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>
    </div>
  );
}

function IndexPageNew({ broker }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    kvkk: false,
    recaptcha: false
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const brokerLogo = broker?.logo_url || '';
  const brokerName = broker?.name || 'Trading Platform';
  
  // Landing page config
  const config = broker?.landing_page_config || {};
  const heroTitle = config.hero_title || 'Hoş Geldiniz';
  const heroSubtitle = config.hero_subtitle || brokerName;
  const heroButtonText = config.hero_button_text || 'Hemen Başla';

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name || !formData.email || !formData.phone) {
      alert('Lütfen tüm alanları doldurunuz.');
      return;
    }
    
    if (!formData.kvkk) {
      alert('Lütfen KVKK formunu onaylayınız.');
      return;
    }
    
    if (!formData.recaptcha) {
      alert('Lütfen robot olmadığınızı doğrulayınız.');
      return;
    }
    
    // Show success message
    setFormSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        kvkk: false,
        recaptcha: false
      });
    }, 3000);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header/Navbar - Desktop */}
      <header className="hidden md:block fixed top-0 left-0 right-0 z-40 bg-gray-100 py-2">
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="flex items-stretch h-16 shadow-lg">
            {/* Logo - Beyaz Zemin */}
            <div className="bg-white px-6 flex items-center justify-center min-w-[220px]">
              {brokerLogo ? (
                <img 
                  src={getFullAssetUrl(brokerLogo)} 
                  alt={brokerName} 
                  className="h-full w-auto object-contain max-w-full py-2" 
                />
              ) : (
                <div className="w-32 h-full flex items-center justify-center py-2">
                  <svg viewBox="0 0 100 60" className="w-full h-full">
                    <path d="M18 55 Q18 5 50 5 Q82 5 82 55" fill="none" stroke="#26c6da" strokeWidth="6"/>
                    <path d="M30 55 Q30 18 50 18 Q70 18 70 55" fill="none" stroke="#1e5a8e" strokeWidth="6"/>
                  </svg>
                </div>
              )}
            </div>
            
            {/* Navigation Menu - Gradient Bloklar */}
            <button onClick={() => navigate('/yatirim')} className="flex items-center justify-center px-5 bg-[#26c6da] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">YATIRIM</button>
            <button onClick={() => navigate('/viop')} className="flex items-center justify-center px-5 bg-[#1ea8c1] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">VİOP</button>
            <button onClick={() => navigate('/forex')} className="flex items-center justify-center px-5 bg-[#1a8faa] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">FOREX</button>
            <button onClick={() => navigate('/portfoy')} className="flex items-center justify-center px-5 bg-[#167892] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">PORTFÖY</button>
            <button onClick={() => navigate('/meksanaliz')} className="flex items-center justify-center px-4 bg-[#136079] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">MEKSANALİZ</button>
            <button onClick={() => navigate('/yurtdisi')} className="flex items-center justify-center px-5 bg-[#1a6f8d] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">MEXİ</button>
            <button onClick={() => navigate('/yurtdisi')} className="flex items-center justify-center px-3 bg-[#16536a] text-white text-[11px] font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">YURTDIŞI PİYASALAR</button>
            <button onClick={() => navigate('/login')} className="flex items-center justify-center px-5 bg-[#145868] text-white text-xs font-bold cursor-pointer hover:opacity-90 transition-opacity whitespace-nowrap">E-ŞUBE</button>
            
            {/* FX GİRİŞ ve HESAP AÇ - Aynı satırda */}
            <button 
              onClick={() => navigate('/login')}
              className="flex items-center justify-center px-8 bg-[#0d3a4d] text-white font-bold text-xs hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              FX GİRİŞ
            </button>
            <button 
              onClick={() => navigate('/login?mode=register')}
              className="flex items-center justify-center px-8 bg-white text-[#0d3a4d] font-bold text-xs hover:bg-gray-50 transition-colors whitespace-nowrap border-l border-gray-200"
            >
              HESAP AÇ
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Header */}
      <header className="md:hidden bg-white shadow-md fixed top-0 left-0 right-0 z-40">
        <div className="flex items-center justify-between px-3 py-0.5">
          {brokerLogo ? (
            <img 
              src={getFullAssetUrl(brokerLogo)} 
              alt={brokerName} 
              className="h-24 w-auto object-contain" 
            />
          ) : (
            <div className="h-24 w-40 flex items-center justify-center">
              <svg viewBox="0 0 140 80" className="w-full h-full">
                <path d="M20 75 Q20 5 70 5 Q120 5 120 75" fill="none" stroke="#26c6da" strokeWidth="7"/>
                <path d="M35 75 Q35 22 70 22 Q105 22 105 75" fill="none" stroke="#1e5a8e" strokeWidth="7"/>
              </svg>
            </div>
          )}
          
          <button 
            onClick={() => setMenuOpen(!menuOpen)}
            className="p-1"
          >
            <svg className="w-8 h-8 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black/60 z-50 md:hidden" onClick={() => setMenuOpen(false)}>
          <div className="absolute right-0 top-0 bottom-0 w-80 bg-[#0d3a4d] shadow-2xl" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center justify-between p-4 bg-[#0a2e3d]">
              <div className="flex items-center gap-2">
                {brokerLogo ? (
                  <img 
                    src={getFullAssetUrl(brokerLogo)} 
                    alt={brokerName} 
                    className="h-8 w-auto object-contain" 
                  />
                ) : (
                  <div className="w-12 h-8 flex items-center justify-center">
                    <svg viewBox="0 0 60 40" className="w-full h-full">
                      <path d="M10 35 Q10 5 30 5 Q50 5 50 35" fill="none" stroke="#26c6da" strokeWidth="3"/>
                      <path d="M15 35 Q15 12 30 12 Q45 12 45 35" fill="none" stroke="#fff" strokeWidth="3"/>
                    </svg>
                  </div>
                )}
              </div>
              <button onClick={() => setMenuOpen(false)} className="text-white p-2">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Menu Items */}
            <nav className="flex flex-col">
              <button onClick={() => { navigate('/yatirim'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#26c6da] text-white text-sm font-bold text-left">YATIRIM</button>
              <button onClick={() => { navigate('/viop'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#1ea8c1] text-white text-sm font-bold text-left">VİOP</button>
              <button onClick={() => { navigate('/forex'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#1a8faa] text-white text-sm font-bold text-left">FOREX</button>
              <button onClick={() => { navigate('/portfoy'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#167892] text-white text-sm font-bold text-left">PORTFÖY</button>
              <button onClick={() => { navigate('/meksanaliz'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#136079] text-white text-sm font-bold text-left">MEKSANALİZ</button>
              <button onClick={() => { navigate('/yurtdisi'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#1a6f8d] text-white text-sm font-bold text-left">MEXİ</button>
              <button onClick={() => { navigate('/yurtdisi'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#16536a] text-white text-sm font-bold text-left">YURTDIŞI PİYASALAR</button>
              <button onClick={() => { navigate('/login'); setMenuOpen(false); }} className="w-full px-6 py-4 bg-[#145868] text-white text-sm font-bold text-left">E-ŞUBE</button>
              <button 
                onClick={() => { navigate('/login'); setMenuOpen(false); }}
                className="w-full px-6 py-4 bg-[#0d3a4d] text-white text-sm font-bold text-left"
              >
                FX GİRİŞ
              </button>
              <button 
                onClick={() => { navigate('/login?mode=register'); setMenuOpen(false); }}
                className="w-full px-6 py-4 bg-white text-[#0d3a4d] text-sm font-bold text-left"
              >
                HESAP AÇ
              </button>
            </nav>
          </div>
        </div>
      )}

      {/* Content Area */}
      <div className="pt-[8vh]">
        {/* Slider + Social Media Row */}
        <div className="relative">
          {/* Slider Section */}
          <SliderSection />
          
          {/* Social Media Sidebar - Absolute positioned on right */}
          <div className="hidden md:flex flex-col gap-[10px] items-center absolute right-[5px] top-1/2 -translate-y-1/2 z-20">
              <a href="tel:+908502220212" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25 1.12.37 2.32.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-gray-400 hover:bg-gray-500 flex items-center justify-center rounded-lg transition-colors">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>
        
        {/* About Section - Below Slider */}
        <div className="bg-white py-10">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-[32px] font-bold text-[#1e5a8e] mb-5 tracking-wide">MEKSA YATIRIM</h2>
            <p className="text-gray-600 text-base leading-[1.5] mb-10">
                28 Haziran 1990 yılında kurulan Meksa Menkul Değerler Ticareti A.Ş. 1998 yılında 
                Meksa Yatırım Menkul Değerler A.Ş. unvanını almıştır. Borsa İstanbul'da faaliye 
                gösteren önde gelen aracı kurumlardan biri olan Meksa Yatırım yurtiçinde 11 şube ve 
                irtibat bürosu ile bireysel ve kurumsal müşterilerine kapsamlı sermaye piyasaları 
                aracılık hizmetleri sunmaktadır.
            </p>
            
            {/* Info Section - NO BORDER */}
            <div className="flex gap-6 items-start mt-8">
              {/* Logo */}
              <div className="flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_custom-broker-ui/artifacts/6jy5o4dr_image.png"
                  alt="Certificate"
                  className="w-24 h-24 md:w-32 md:h-32 object-contain"
                />
              </div>
              
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-[#26c6da] mb-3">MeksaYatırım</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                  BIST'te faaliyet gösteren önde gelen aracı kurumlarından biri olan Meksa Yatırım 
                  bireysel ve kurumsal müşterilerine kapsamlı aracılık hizmetleri sunmaktadır.
                </p>
                <button className="px-6 py-2 md:px-8 md:py-3 bg-white border-2 border-[#26c6da] text-[#1e5a8e] rounded-lg font-semibold hover:bg-cyan-50 transition-colors text-sm md:text-base">
                  Detaylı Bilgi
                </button>
              </div>
            </div>
            
            {/* MeksaFX Section */}
            <div className="flex gap-6 items-start mt-12">
              {/* Logo */}
              <div className="flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/81qfnj57_image.png"
                  alt="MeksaFX Logo"
                  className="w-24 h-24 md:w-32 md:h-32 object-contain"
                />
              </div>
              
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-[#1e5a8e] mb-3">MeksaFX</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                  35 Yıllık Meksa Tecrübesi ile Dünyanın en büyük finans piyasası olan FOREX e 
                  MeksaFX avantajları ve Fırsatları ile adım atın.
                </p>
                <button className="px-6 py-2 md:px-8 md:py-3 bg-white border-2 border-[#26c6da] text-[#1e5a8e] rounded-lg font-semibold hover:bg-cyan-50 transition-colors text-sm md:text-base">
                  Detaylı Bilgi
                </button>
              </div>
            </div>
            
            {/* Meksa VİOP Section */}
            <div className="flex gap-6 items-start mt-12">
              {/* Logo */}
              <div className="flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/jjjcltxr_image.png"
                  alt="Meksa VİOP Logo"
                  className="w-24 h-24 md:w-32 md:h-32 object-contain"
                />
              </div>
              
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-[#1e5a8e] mb-3">Meksa VİOP</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                  35 yıllık Meksa Yatırım tecrübesini teknolojiye uyumlu hale getirip, kişiye 
                  özel hizmet veren Türkiye'nin en tecrübeli, en geniş, en dinamik VİOP 
                  departmanının sayfası.
                </p>
                <button className="px-6 py-2 md:px-8 md:py-3 bg-white border-2 border-[#26c6da] text-[#1e5a8e] rounded-lg font-semibold hover:bg-cyan-50 transition-colors text-sm md:text-base">
                  Detaylı Bilgi
                </button>
              </div>
            </div>
            
            {/* Meksa Portföy Section */}
            <div className="flex gap-6 items-start mt-12">
              {/* Logo */}
              <div className="flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/kl8delcz_image.png"
                  alt="Meksa Portföy Logo"
                  className="w-24 h-24 md:w-32 md:h-32 object-contain"
                />
              </div>
              
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-[#1e5a8e] mb-3">Meksa Portföy</h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                  Firmamız konularında uzman personeli ile yatırımcıların risk tercihleri 
                  doğrultusunda amaçladıkları getiriye ulaştırmayı hedeflemektedir.
                </p>
                <button className="px-6 py-2 md:px-8 md:py-3 bg-white border-2 border-[#26c6da] text-[#1e5a8e] rounded-lg font-semibold hover:bg-cyan-50 transition-colors text-sm md:text-base">
                  Detaylı Bilgi
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="bg-gradient-to-br from-[#2563eb] via-[#1e5a8e] to-[#1e3a8a] py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-white text-2xl md:text-3xl font-bold text-center mb-8 leading-snug">
              Meksa Advisor Mobil Uygulaması Hakkında Bilgi Almak İstiyorum
            </h2>
            
            <div className="w-full h-1 bg-white mb-8"></div>
            
            {formSubmitted ? (
              <div className="bg-white rounded-lg p-8 text-center">
                <div className="text-green-600 text-3xl mb-4">✓</div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Başarılı!</h3>
                <p className="text-gray-600">Formunuz başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.</p>
              </div>
            ) : (
              <form className="space-y-5" onSubmit={handleFormSubmit}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Adınız Soyadınız"
                  className="w-full px-6 py-4 text-lg text-gray-500 bg-white rounded-lg border-none outline-none placeholder-gray-400"
                />
                
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="E-Mail Adresiniz"
                  className="w-full px-6 py-4 text-lg text-gray-500 bg-white rounded-lg border-none outline-none placeholder-gray-400"
                />
                
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Telefon Numaranız"
                  className="w-full px-6 py-4 text-lg text-gray-500 bg-white rounded-lg border-none outline-none placeholder-gray-400"
                />
                
                <p className="text-white text-sm md:text-base">
                  Telefon numaranızı başında 0 olmadan yazınız. 5305219822 gibi
                </p>
                
                <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    id="kvkk"
                    name="kvkk"
                    checked={formData.kvkk}
                    onChange={handleInputChange}
                    className="mt-1 w-5 h-5 rounded border-white"
                  />
                  <label htmlFor="kvkk" className="text-white text-sm md:text-base leading-relaxed">
                    <span className="font-bold">Kişisel Verilerin Korunması Kanunu</span> formunu okudum, onaylıyorum.
                  </label>
                </div>
                
                <div className="bg-white rounded-lg p-6 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      id="recaptcha"
                      name="recaptcha"
                      checked={formData.recaptcha}
                      onChange={handleInputChange}
                      className="w-6 h-6 rounded border-gray-300"
                    />
                    <span className="text-gray-700 text-base">Ben robot değilim</span>
                  </div>
                  <div className="flex flex-col items-end">
                    <img 
                      src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/n5a9f8kq_image.png" 
                      alt="reCAPTCHA" 
                      className="w-16 h-16 object-contain"
                    />
                    <span className="text-xs text-gray-400 mt-1">reCAPTCHA</span>
                  </div>
                </div>
                
                <p className="text-white text-xs md:text-sm italic">
                  This question is for testing whether or not you are a human visitor and to prevent automated spam submissions.
                </p>
                
                <button
                  type="submit"
                  className="px-12 py-4 bg-[#26c6da] text-white text-xl font-bold rounded-lg hover:bg-[#1ea8c1] transition-colors"
                >
                  Gönder
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Pasifik Holding Banner Section */}
        <div className="bg-white py-8 px-4">
          <div className="max-w-7xl mx-auto">
            <img 
              src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/obrh8jvw_image.png"
              alt="Pasifik Holding Halka Açılıyor"
              className="w-full h-auto object-contain rounded-lg"
            />
          </div>
        </div>

        {/* Meksa Duyurular Section */}
        <div className="bg-gray-100 py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">
              <span className="text-[#26c6da]">MEKSA</span>
              <span className="text-gray-300"> DUYURULAR</span>
            </h2>
            
            <div className="bg-white rounded-lg shadow-md p-8">
              <h3 className="text-[#26c6da] text-xl md:text-2xl font-normal mb-6 leading-relaxed">
                Ecogreen Enerji Holding A.Ş. Fiyat Tespit<br className="hidden md:block" />
                Raporu'na İlişkin Analist Raporu
              </h3>
              
              <p className="text-gray-400 text-lg mb-8">22.10.2025</p>
              
              <div className="flex justify-end">
                <button className="text-[#26c6da] text-xl font-light hover:underline">
                  Tüm Duyurular
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Meksa VİOP Algoritmalar Section */}
        <div className="bg-gray-100 py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <img 
              src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/xo2er44d_image.png"
              alt="Meksa VİOP Algoritmalar"
              className="w-full h-auto object-contain rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* Meksa Hesap Section */}
        <div className="bg-white py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">
              <span className="text-[#26c6da]">MEKSA</span>
              <span className="text-gray-300"> HESAP</span>
            </h2>
            
            <div 
              className="relative w-full rounded-lg overflow-hidden shadow-lg"
              style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&q=80)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              {/* Dark Blur Overlay */}
              <div className="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>
              
              {/* Buttons Container */}
              <div className="relative z-10 p-6 md:p-10 flex flex-col gap-4 max-w-2xl">
                {/* Hesap Açın Button */}
                <button 
                  onClick={() => navigate('/login')}
                  className="w-full flex items-center gap-3 px-6 py-3 bg-transparent border-2 border-white rounded-lg text-white text-lg md:text-xl font-normal hover:bg-white/10 transition-all"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                  </svg>
                  Hesap Açın!
                </button>
                
                {/* E-ŞUBE Button */}
                <button 
                  onClick={() => navigate('/login')}
                  className="w-full flex items-center gap-3 px-6 py-3 bg-transparent border-2 border-white rounded-lg text-white text-lg md:text-xl font-normal hover:bg-white/10 transition-all"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  E-ŞUBE
                </button>
                
                {/* FX GİRİŞ Button */}
                <button 
                  onClick={() => navigate('/login')}
                  className="w-full flex items-center gap-3 px-6 py-3 bg-transparent border-2 border-white rounded-lg text-white text-lg md:text-xl font-normal hover:bg-white/10 transition-all"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"/>
                  </svg>
                  FX GİRİŞ
                </button>
                
                {/* İdeal Web İçin Tıklayın Button */}
                <button 
                  className="w-full flex items-center gap-3 px-6 py-3 bg-transparent border-2 border-white rounded-lg text-white text-lg md:text-xl font-normal hover:bg-white/10 transition-all"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"/>
                  </svg>
                  İdeal Web İçin Tıklayın
                </button>
                
                {/* Hesap Bilgilerimiz Button */}
                <button 
                  className="w-full flex items-center gap-3 px-6 py-3 bg-transparent border-2 border-white rounded-lg text-white text-lg md:text-xl font-normal hover:bg-white/10 transition-all"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  Hesap Bilgilerimiz
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* E-Bülten Section */}
        <div className="bg-gray-400 py-6 px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-white text-xl md:text-2xl font-light mb-2">
              E-Bültenimize Kayıt Olun.
            </h2>
            
            <p className="text-white text-sm md:text-base mb-4 font-light">
              Tüm yenilik ve bilgilendirmelerden haberdar olun!
            </p>
            
            <form className="space-y-3 max-w-xl mx-auto" onSubmit={(e) => e.preventDefault()}>
              <select
                className="w-full px-4 py-3 text-base text-gray-500 bg-white rounded-lg border-none outline-none"
              >
                <option value="">Lütfen seçiniz</option>
                <option value="yatirimci">Yatırımcı</option>
                <option value="kurumsal">Kurumsal</option>
              </select>
              
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-base">@</span>
                <input
                  type="email"
                  placeholder="E-Posta Adresiniz"
                  className="w-full pl-10 pr-4 py-3 text-base text-gray-500 bg-white rounded-lg border-none outline-none placeholder-gray-400"
                />
              </div>
              
              <button
                type="submit"
                className="w-full py-3 bg-[#26c6da] text-white text-lg md:text-xl font-bold rounded-lg hover:bg-[#1ea8c1] transition-colors tracking-wider"
              >
                KAYIT OL
              </button>
              
              <div className="bg-white rounded-lg p-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="ebulten-recaptcha"
                    className="w-5 h-5 rounded border-gray-300"
                  />
                  <span className="text-gray-700 text-sm">Ben robot değilim</span>
                </div>
                <div className="flex flex-col items-end">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_brokerportal-2/artifacts/n5a9f8kq_image.png" 
                    alt="reCAPTCHA" 
                    className="w-12 h-12 object-contain"
                  />
                  <span className="text-xs text-gray-400">reCAPTCHA</span>
                </div>
              </div>
              
              <p className="text-white text-xs italic">
                This question is for testing whether or not you are a human visitor and to prevent automated spam submissions.
              </p>
            </form>
          </div>
        </div>

        {/* Değerli Müşterimiz Section */}
        <div className="bg-gray-100 py-10 px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-6">
              Değerli Müşterimiz,
            </h2>
            
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-8">
              Mali Suçları Araştırma Kurumu (MASAK) tarafından yayımlanan "Suç Gelirlerinin Aklanmasının ve Terörün 
              Finansmanının Önlenmesine Dair Tedbirler Hakkında Yönetmelik" ile hesap açılışlarında kimlik ve adres 
              tesbitine ilişkin yeni yükümlülükler getirilmiştir. Bu yasal gereklilik kapsamında, daha önce hesap 
              açtırırken beyan ettiğiniz adres bilginizin teyidi amacıyla, adınıza düzenlenmiş elektrik, su, doğalgaz, 
              telefon gibi abonelik gerektiren hizmete ilişkin olan bir faturanın (ibraz tarihinden önceki üç aylık 
              döneme ait) ya da Yerleşim Yeri Belgesinin en geç 01 Eylül 2009 tarihine kadar şubemize ibraz edilmesi 
              ve kimlik tesbitine ilişkin var ise diğer eksik bilgilerinizin tamamlanması gerekmektedir. 01 Eylül 2009 
              sonrası işlemlerinizin aksamaması için bilgi ve belgelerinizi belirtilen yasal süre içinde tamamlamanız 
              için şubemizle temasa geçmenizi önemle rica ederiz.
            </p>
          </div>
        </div>

        {/* Çekince Section */}
        <div className="bg-white py-10 px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-6">
              Çekince
            </h2>
            
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              Mali Suçları Araştırma Kurumu (MASAK) tarafından yayımlanan "Suç Gelirlerinin Aklanmasının ve Terörün 
              Finansmanının Önlenmesine Dair Tedbirler Hakkında Yönetmelik" ile hesap açılışlarında kimlik ve adres 
              tespitine ilişkin yeni yükümlülükler getirilmiştir. BIST Hisse Senetleri ve Tahvil Piyasası verileri 
              en az 15 dakika gecikmelidir. BIST isim ve logosu Koruma Marka Belgesi altında korunmakta olup izinsiz 
              kullanılamaz, iktibas edilemez, değiştirilemez. BIST ismi altında açıklanan tüm bilgilerin telif hakları 
              tamamen BIST'ye ait olup tekrar yayımlanamaz.
            </p>
          </div>
        </div>

        {/* Yasal Uyarı Section */}
        <div className="bg-gray-100 py-10 px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-6">
              YASAL UYARI
            </h2>
            
            <div className="space-y-6 text-gray-600 text-sm md:text-base leading-relaxed">
              <p>
                BIST piyasalarında oluşan tüm verilere ait telif hakları tamamen BIST'ye ait olup, bu veriler tekrar 
                yayınlanamaz. Bu web sitesinde yer alan her türlü, görüş, bilgi, değerlendirme, yorum ve istatistiki 
                şekil ve değerler güvenilir olduğuna inanılan kaynaklardan elde edilmiş olup, İDEAL DATA FİNANSAL 
                TEKNOLOJİLER A.Ş. bunların doğruluğu ve yeterliliğini hiçbir şekilde garanti etmemektedir. Bununla 
                beraber gerek site üzerindeki, gerekse site için kullanılan kaynaklardaki hata ve eksikliklerden ve 
                sitedeki bilgilerin kullanılması sonucunda yatırımcıların uğrayabilecekleri doğrudan ve/veya dolaylı 
                zararlardan, kar yoksunluğundan, manevi zararlardan ve üçüncü kişilerin uğrayabileceği zararlardan 
                dolayı İDEAL DATA FİNANSAL TEKNOLOJİLER A.Ş. hiçbir şekilde sorumlu tutulamaz.
              </p>
              
              <p>
                Burada yer alan yatırım bilgi, yorum ve tavsiyeleri yatırım danışmanlığı kapsamında değildir. Yatırım 
                danışmanlığı hizmeti; aracı kurumlar, portföy yönetim şirketleri, mevduat kabul etmeyen bankalar ile 
                müşteri arasında imzalanacak yatırım danışmanlığı sözleşmesi çerçevesinde sunulmaktadır. Burada yer 
                alan yorum ve tavsiyeler, yorum ve tavsiyede bulunanların kişisel görüşlerine dayanmaktadır. Bu görüşler 
                mali durumunuz ile risk ve getiri tercihlerinize uygun olmayabilir. Bu nedenle, sadece burada yer alan 
                bilgilere dayanılarak yatırım kararı verilmesi beklentilerinize uygun sonuçlar doğurmayabilir.
              </p>
              
              <p className="font-semibold">
                Veriler 15 dakika gecikmelidir.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-[#1e5a8e] py-12 px-4">
          <div className="max-w-6xl mx-auto">
            <nav className="flex flex-col space-y-6 text-white">
              <button onClick={() => navigate('/duyurular')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Duyurular
              </button>
              
              <button onClick={() => navigate('/kvkk')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                KVKK
              </button>
              
              <button onClick={() => navigate('/hakkimizda')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Hakkımızda
              </button>
              
              <button onClick={() => navigate('/hesap-bilgileri')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Hesap Bilgilerimiz
              </button>
              
              <button onClick={() => navigate('/blog')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Blog
              </button>
              
              <button onClick={() => navigate('/iletisim')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Bize Ulaşın
              </button>
              
              <button onClick={() => navigate('/sikayet-formu')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Müşteri Şikayet Formu
              </button>
              
              <button onClick={() => navigate('/bilgi-toplumu')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Bilgi Toplumu Hiz
              </button>
              
              <button onClick={() => navigate('/zamanasimi')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Zamanaşımı Duyuruları
              </button>
              
              <button onClick={() => navigate('/masraf-ucret')} className="text-xl md:text-2xl font-light hover:text-[#26c6da] transition-colors text-left">
                Masraf Ücret ve Komisyonlar
              </button>
            </nav>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default IndexPageNew;
